<div class="sidenav-sm p-0 w-100 h-100">
  <div class="d-flex w-100 h-100 flex-column p-4">

    <div class="d-flex">
      <span class="flex-grow-1"></span>
      <button mat-icon-button
        (click)="closeSidenav()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    @if (storeService.store?.user) {
      <div class="pt-3">
        <div class="d-flex align-items-center gap-3">
          @if (storeService.store.user?.photo?.url) {
            <img [src]="storeService.store.user.photo.url"
              alt="Profile photo"
              class="profile-photo"
              (error)="onPhotoError()" />
          }
          <div>
            <span class="title">
              {{ 'COMMON.LABEL.HI' | translate }}
              @if (storeService.store.user?.role.type !== eUsersRole.AGENT) {
                <span>!</span>
              }
              @if (storeService.store.user?.role.type === eUsersRole.AGENT) {
                <span>,
                  {{ storeService.store?.user?.name }}
                  {{ storeService.store?.user?.surname }}</span>
              }
            </span>
            <div>
              <span class="subtitle">{{ storeService?.store?.user?.email }}</span>
            </div>
          </div>
        </div>

        @if (storeService.store.user?.role.type === eUsersRole.AGENT) {
          <div
            class="mt-4 d-flex justify-content-between role px-2 py-1 w-100 align-items-center rounded-pill">
            <div class="d-flex align-items-center">
              <span>
                {{ 'COMMON.LABEL.AGENT_ID' | translate }}
              </span>

              <span class="agentCode">
                : {{ storeService.store.user?.agentCode }}
              </span>
            </div>

            <button mat-icon-button
              [cdkCopyToClipboard]="storeService.store?.user?.agentCode">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        }

      </div>
    }

    <mat-divider class="mt-4 mb-4"></mat-divider>

    <div class="flex-grow-1 d-flex flex-column justify-content-between">
      <mat-nav-list>

        @if (storeService.store?.user?.canViewAiApp) {
          <a mat-list-item
            href="https://ai.casa-doc.it/"
            target="_blank"
            class="mb-2">
            <mat-icon matListItemIcon>photo</mat-icon>
            <div matListItemTitle>Casadoc AI</div>
          </a>
        }

        @if (!storeService.store?.user?.canViewAdmin) {
          <a mat-list-item
            #linkActive="routerLinkActive"
            routerLinkActive
            [activated]="linkActive.isActive"
            routerLink="/"
            class="mb-2"
            (click)="closeSidenav()">
            <mat-icon matListItemIcon>menu_book</mat-icon>
            <div matListItemTitle>{{ 'COMMON.BOOKLET.BOOKLETS' | translate }}</div>
          </a>
        }


        @if (storeService.store?.user?.isSurveyor) {
          <a mat-list-item
            #assignmentsLinkActive="routerLinkActive"
            routerLinkActive
            [activated]="assignmentsLinkActive.isActive"
            routerLink="/admin/assignments"
            class="mb-2"
            (click)="closeSidenav()">
            <mat-icon matListItemIcon>assignment_turned_in</mat-icon>
            <div matListItemTitle>{{ 'ADMIN.ASSIGNMENTS.NAV_TITLE' | translate }}</div>
          </a>
        }

        <a mat-list-item
          #linkActive="routerLinkActive"
          routerLinkActive
          [activated]="linkActive.isActive"
          routerLink="/profile"
          class="mb-2"
          (click)="closeSidenav()">
          <mat-icon matListItemIcon>account_circle</mat-icon>
          <div matListItemTitle>{{ 'COMMON.LABEL.PROFILE' | translate }}</div>
        </a>
      </mat-nav-list>
      <div>
        <mat-nav-list>
          <a mat-list-item
            href="mailto:{{infoMail}}"
            (click)="closeSidenav()">
            <div matListItemTitle>{{ 'COMMON.LABEL.CONTACT_US' | translate }}</div>
          </a>
          <a mat-list-item
            (click)="openPrivacyPolicy()">
            <div matListItemTitle>{{ 'COMMON.LABEL.PRIVACY_POLICY' | translate }}</div>
          </a>
          <a mat-list-item
            (click)="openCookiePolicy()">
            <div matListItemTitle>{{ 'COMMON.LABEL.COOKIE_POLICY' | translate }}</div>
          </a>
          <a mat-list-item
            (click)="openTermsAndConditions()">
            <div matListItemTitle>{{ 'COMMON.LABEL.TERMS_AND_CONDITION' | translate }}</div>
          </a>
          <a mat-list-item
            (click)="openCookiePreferences()">
            <div matListItemTitle>{{ 'COMMON.LABEL.COOKIE_PREFERENCES' | translate }}</div>
          </a>
        </mat-nav-list>
      </div>
    </div>


    <div class="d-flex">
      <span class="d-flex mat-body-small align-items-center">
        v{{ appVersion }}
      </span>
      <div class="ml-1">
        <bitf-mat-language-selector></bitf-mat-language-selector>
      </div>
      <span class="flex-grow-1"></span>
      <button mat-flat-button
        class="error"
        (click)="onSignOut()">
        Logout
      </button>
    </div>

  </div>
</div>